import { render, staticRenderFns } from "./BusinessPaymentModal.vue?vue&type=template&id=df4f6fae&"
import script from "./BusinessPaymentModal.vue?vue&type=script&lang=js&"
export * from "./BusinessPaymentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports